import React from "react";
import { useTranslation } from "react-i18next";
import { SPOTInput } from "spot-component-library/lib/components/form/spotInput/SPOTInput";
import { FormFieldProps } from "spot-component-library/src/components/form/spotInput/SPOTInput";
import { RateAgreementOptions } from "../../../types/RateAgreementOptions";
import { RateData } from "../../../types/RateData";

export function RateAmountInput(
    props: {
        rateAgreementOptions: RateAgreementOptions;
        rateData: RateData;
    } & Pick<FormFieldProps, "label" | "errors" | "register" | "onChange">
) {
    const { t } = useTranslation();

    return (
        <SPOTInput
            id={"rateAmount"}
            name={"rateAmount"}
            label={props.label}
            maxLength={20}
            errors={props.errors}
            placeholder={props.rateAgreementOptions.minRate + " Mindesrate"}
            defaultValue={props.rateData.rateAmount}
            register={props.register}
            required={t("APP_ROOT.VALIDATION.MESSAGE_REQUIRED")}
            min={{
                value: props.rateAgreementOptions.minRate,
                message: t("APP_ROOT.VALIDATION.MESSAGE_MIN_VALUE"),
            }}
            max={{
                value: props.rateAgreementOptions.maxRate,
                message: t("APP_ROOT.VALIDATION.MESSAGE_MAX_VALUE"),
            }}
            pattern={{
                value: /^([0-9]+(?:[0-9]*)?)$/,
                message: t("APP_ROOT.VALIDATION.MESSAGE_NUMBERS"),
            }}
            onChange={props.onChange}
        />
    );
}
